module.exports = __webpack_public_path__ + "img/15.78a31e06.png";